module.exports = __webpack_public_path__ + "img/km.60933b69.jpg";